export const reviewAppraisalTaskAction = {
  ACCEPTED: 'accepted',
  REVISION: 'revision_required',
  FOLLOW_UP: 'follow_up',
  DQ: 'dq',
};
